// let items = document
//     .querySelector(".header__inline-mega-menu")
//     .querySelectorAll("details");

// let dropdownItems = document.querySelector(".mega-menu__content");

// items.forEach((item) => {
//     item.addEventListener("mouseenter", () => {
//         item.setAttribute("open", true);
//         let ulElement = item.querySelector("ul");
//         if (ulElement !== null) {
//             ulElement.addEventListener("mouseleave", () => {
//                 item.removeAttribute("open");
//             });
//         }
//     });
//     item.addEventListener("focus", () => {
//         item.setAttribute("open", true);
//     });
//     item.addEventListener("blur", () => {
//         item.removeAttribute("open");
//     });
//     item.addEventListener("mouseenter", () => {
//         item.setAttribute("open", "");
//     });
//     item.addEventListener("mouseleave", () => {
//         // item.removeAttribute("open");
//     });
// });
// if (dropdownItems !== null) {
//     dropdownItems.addEventListener("mouseleave", () => {
//         items.forEach((item) => {
//             item.removeAttribute("open");
//         });
//     });
// }


let menus = document.querySelectorAll('js-mega-menu');

class HeaderMenuNew extends HTMLElement{
    constructor(){
        super()
        this.menu = this.querySelector('.js-mega-menu')
        this.submenu = this.querySelectorAll('.js-submenu-child')
        this.setup()
    }

    setup(){
        window.addEventListener('DOMContentLoaded', () => {
            this.menu.addEventListener('mouseenter', this.openMenu.bind(this))
            this.menu.addEventListener('mouseleave', this.closeMenu.bind(this));
            this.submenu.forEach((menuItem) => {
                menuItem?.addEventListener('mouseenter', this.openMenu.bind(this));
                menuItem?.addEventListener('mouseleave', this.closeMenu.bind(this));
            });
            
            // this.menu.querySelector('.mega-menu__content').addEventListener('mouseleave', this.closeMenu.bind(this));

        })
    }

    openMenu(event){
        let ulElement = event.relatedTarget ? event.relatedTarget.querySelector("ul") : null;
        if (ulElement !== null) {
            ulElement.addEventListener("mouseleave", () => {
                event.target.removeAttribute("open");
            });
        }
        event.target.setAttribute("open", true)
    }

    closeMenu(event){
        let content = event?.relatedTarget && event.relatedTarget.querySelector('.mega-menu__content');
        if(content){
            let currenrtId = event.target.id.split('Details-HeaderMenu-')[1];
            let contentId = content.id.split('MegaMenu-Content-')[1];
            if(currenrtId !== contentId){
                event.target.removeAttribute("open")
            }
        }else{
            event.target.removeAttribute("open")
        }
    }
}

customElements.define("header-menu-new", HeaderMenuNew);



document.addEventListener('DOMContentLoaded', () => {
  let headerSearchbutton = document.querySelectorAll('[data-action="header-search-btn"]');
  let SearchDetailsWraper = document.querySelector('.header__search details');
  headerSearchbutton.forEach((btn) => {
      btn.addEventListener("click", (event) => {
          event.stopPropagation();
          if(SearchDetailsWraper){
              SearchDetailsWraper.open = true;
              SearchDetailsWraper.querySelector('input.search__input')?.focus();
          }
          document.body.classList.add("overflow-hidden");
      });
  });

  // Close when clicking outside the search wrapper
  document.addEventListener('click', (event) => {
    const searModelInside = SearchDetailsWraper.querySelector('.search-modal__content').contains(event.target);
    const searchIsOpen = SearchDetailsWraper.hasAttribute('open');
    if (!searModelInside && searchIsOpen) {
      SearchDetailsWraper.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
  });

});
